var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 3.00065C1.33337 2.08018 2.07957 1.33398 3.00004 1.33398H4.66671C5.58718 1.33398 6.33337 2.08018 6.33337 3.00065V4.66732C6.33337 5.58779 5.58718 6.33398 4.66671 6.33398H3.00004C2.07957 6.33398 1.33337 5.58779 1.33337 4.66732V3.00065Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 3.00065C9.66671 2.08018 10.4129 1.33398 11.3334 1.33398H13C13.9205 1.33398 14.6667 2.08018 14.6667 3.00065V4.66732C14.6667 5.58779 13.9205 6.33398 13 6.33398H11.3334C10.4129 6.33398 9.66671 5.58779 9.66671 4.66732V3.00065Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 11.334C1.33337 10.4135 2.07957 9.66732 3.00004 9.66732H4.66671C5.58718 9.66732 6.33337 10.4135 6.33337 11.334V13.0007C6.33337 13.9211 5.58718 14.6673 4.66671 14.6673H3.00004C2.07957 14.6673 1.33337 13.9211 1.33337 13.0007V11.334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 11.334C9.66671 10.4135 10.4129 9.66732 11.3334 9.66732H13C13.9205 9.66732 14.6667 10.4135 14.6667 11.334V13.0007C14.6667 13.9211 13.9205 14.6673 13 14.6673H11.3334C10.4129 14.6673 9.66671 13.9211 9.66671 13.0007V11.334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.29d7eda8319bb7d1999c3a240b423eb3.svg";
export { ForwardRef as ReactComponent };